import { Phone, Mail, MapPin, Clock, ArrowRight } from "lucide-react";
import Seo, { webPageSchema, breadcrumbSchema, organizationSchema } from "@/components/Seo";
import Breadcrumbs from "@/components/Breadcrumbs";
import QuoteForm from "@/components/QuoteForm";
import { COMPANY } from "@/data/company";

export default function KontaktaOss() {
  const path = "/kontakta-oss/";
  const crumbs = [{ name: "Kontakt", path }];
  const schema = [organizationSchema(), webPageSchema(path, "Kontakt – TISAB", "Kontakta TISAB."), breadcrumbSchema(path, crumbs)];

  return (
    <>
      <Seo title="Kontakta TISAB – begär kostnadsfri takoffert" description="Behöver du hjälp med taket i Stockholm eller Mälardalen? Ring TISAB på 08-767 61 20 eller beskriv ditt projekt i formuläret. Begär kostnadsfri offert." path={path} schema={schema} />
      <Breadcrumbs items={crumbs} />

      <section className="container-tisab py-10 md:py-14">
        <div className="max-w-2xl">
          <p className="eyebrow">Kontakt</p>
          <h1 className="mt-4 font-heading text-4xl font-extrabold tracking-tight text-midnight sm:text-5xl">Begär kostnadsfri offert</h1>
          <div className="mt-2 h-0.5 w-24 taklinje" />
          <p className="mt-6 text-lg text-foreground/75">Tre snabba steg ger TISAB kundtyp, behov, adress och kontaktväg – tillräckligt för att börja rätt utan ett långt tekniskt formulär.</p>
        </div>
      </section>

      <section className="section-pad !pt-4">
        <div className="container-tisab">
          <div className="grid gap-7 lg:grid-cols-3">
            <div className="border border-midnight/10 bg-white p-5 shadow-[0_20px_60px_rgba(6,7,8,.06)] sm:p-8 lg:col-span-2 lg:p-10">
              <QuoteForm />
            </div>
            <div className="grid gap-3 sm:grid-cols-2 lg:sticky lg:grid-cols-1 lg:top-32 lg:self-start">
              <div className="border border-tisab/12 bg-[#edf7f1] p-5 sm:p-6">
                <p className="text-xs font-semibold uppercase tracking-wider text-tisab">Direktkontakt</p>
                <ul className="mt-4 space-y-4 text-sm">
                  <li>
                    <a href={COMPANY.phoneHref} className="flex items-center gap-2 font-medium text-midnight hover:text-tisab" data-event="phone_click">
                      <Phone className="h-4 w-4 text-tisab" /> {COMPANY.phone}
                    </a>
                  </li>
                  <li>
                    <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 font-medium text-midnight hover:text-tisab" data-event="email_click">
                      <Mail className="h-4 w-4 text-tisab" /> {COMPANY.email}
                    </a>
                  </li>
                </ul>
              </div>
              <div className="border border-tisab/12 bg-[#edf7f1] p-5 sm:p-6">
                <p className="text-xs font-semibold uppercase tracking-wider text-tisab">Adress</p>
                <p className="mt-3 flex items-start gap-2 text-sm text-foreground/75">
                  <MapPin className="h-4 w-4 shrink-0 text-tisab" /> {COMPANY.fullAddress}
                </p>
                <a href={COMPANY.mapLink} target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-tisab hover:underline" data-event="directions_click">
                  Visa på karta <ArrowRight className="h-3.5 w-3.5" />
                </a>
              </div>
              <div className="border border-tisab/12 bg-[#edf7f1] p-5 sm:p-6">
                <p className="text-xs font-semibold uppercase tracking-wider text-tisab">Öppettider</p>
                <p className="mt-3 flex items-start gap-2 text-sm text-foreground/75">
                  <Clock className="h-4 w-4 shrink-0 text-tisab" /> {COMPANY.hours}
                </p>
              </div>
              <div className="border border-tisab/12 bg-[#edf7f1] p-5 sm:p-6">
                <p className="text-xs font-semibold uppercase tracking-wider text-tisab">Org.nr</p>
                <p className="mt-3 text-sm text-foreground/75">{COMPANY.orgNumber}</p>
                <p className="mt-1 text-xs text-muted-foreground">{COMPANY.legalName} · F-skatt och momsregistrerad</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}